
import { Vue } from "vue-class-component";

export default class FileDownload extends Vue {}
